import type { ComponentType } from 'react';
import { useState } from 'react';
import { Hydrate, QueryClient, QueryClientProvider } from 'react-query';
import type { NextPage } from 'next';
import type { AppProps } from 'next/app';
import { useRouter } from 'next/router';

import MainLayout from 'src/components/Layout/MainLayout';
// import ScriptC from 'src/components/Layout/Script';

type NextPageWithLayout = NextPage & {
	getLayout?: ComponentType<any>;
};

type AppPropsWithLayout = AppProps & {
	Component: NextPageWithLayout;
};

require('src/styles/index.less');

const MyApp = (props: AppPropsWithLayout) => {
	const { Component, pageProps } = props;
	const router = useRouter();

	const [queryClient] = useState(
		() => new QueryClient({ defaultOptions: { queries: { staleTime: 60 * 1000 } } }),
	);
	const Layout = Component.getLayout ?? MainLayout;

	let combinedProps = { ...pageProps };

	return (
		<QueryClientProvider client={queryClient}>
			<Hydrate state={pageProps.dehydratedState}>
				<Layout {...combinedProps} router={router}>
					<>
						{/* <ScriptC /> */}
						<Component {...combinedProps} router={router} />
					</>
				</Layout>
			</Hydrate>
		</QueryClientProvider>
	);
};

export default MyApp;
